import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import mqtt from "mqtt";

const initialState = {
    client: null,
    messages: [],
    connected: false,
    // error: null,
    // loading: false,
    subscribedTopics: [],
};

const mqttSlice = createSlice({
    name: "mqtt",
    initialState,
    reducers: {
        connectMqtt(state, action) {
            state.client = action.payload;
            state.connected = true;
        },
        disconnectMqtt(state) {
            if (state.client) {
                state.client.end();
            }
            state.client = null;
            state.connected = false;
        },
        mqttMessageReceived(state, action) {
            state.messages.push(action.payload);
        },
        addSubscribedTopic(state, action) {
            state.subscribedTopics.push(action.payload);
        },
        clearSubscribedTopics(state) {
            state.subscribedTopics = [];
        },
        removeSubscribedTopic(state, action) {
            state.subscribedTopics = state.subscribedTopics.filter(
                (topic) => topic !== action.payload
            );
        },
    },
});

export const { connectMqtt, disconnectMqtt, mqttMessageReceived, addSubscribedTopic, clearSubscribedTopics, removeSubscribedTopic} = mqttSlice.actions;
export default mqttSlice.reducer;